/**todo: currently amount is price, need to change amount to price and then change numberOfPurchase to amount
 *       also, current Symbol is currency, change that and so symbol is symbol(stockSymbol), currency is currency **/

import {
  Component,
  computed,
  effect,
  inject,
  Injector,
  input,
  InputSignal,
  LOCALE_ID,
  model,
  ModelSignal,
  OnDestroy,
  output,
  OutputEmitterRef,
  signal,
  Signal,
  untracked,
  WritableSignal,
  Inject,
  Optional,
} from "@angular/core";
import { Subscription } from "rxjs";
import { formatCurrencyAmount } from "@bitwarden/web-vault/app/shared/utils/helper-number-format";
import {
  findCategoryById,
  findCategoryByName,
} from "@bitwarden/web-vault/app/shared/utils/helper-categories";
import { editTransactionTab } from "../../gloss/manage/manage-accounts/edit-transaction-details/edit-transaction-details.component";
import { InstitutionOriginEnum } from "../../models/types/institution.type";
import { accountManualType } from "../../models/types/account.types";
import {
  AccountView,
  isBankOrCredit,
  isStockOrOther,
} from "@bitwarden/web-vault/app/models/view/account/account.view";
import { TransactionForm } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/transaction/transaction-form";
import { DialogFactory } from "@bitwarden/web-vault/app/components/dialog/dialogFactory";
import { TransactionStoreService } from "@bitwarden/web-vault/app/services/store/transaction/transaction.store.service";
import { ReferenceDataSource } from "@bitwarden/web-vault/app/models/view/reference-data/reference-data.view";
import { RoleAccessService } from "@bitwarden/web-vault/app/services/permission/role-access.service";
import { ConfirmationDialogService } from "@bitwarden/web-vault/app/services/confirmation/confirmation.service";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { transactionDataType } from "@bitwarden/web-vault/app/models/types/transactionData.types";
import { TransactionStatusEnum } from "@bitwarden/web-vault/app/models/enum/transactionType";
import { TransactionDirection } from "@bitwarden/web-vault/app/models/enum/transactionDirection";
import { TransactionData } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/transaction-details/transaction-details.component";
import { ActionButton } from "@bitwarden/web-vault/app/components/buttons/gloss-button/actionButton";
import { CurrencyType } from "@bitwarden/web-vault/app/models/types/location-currency.types";
import { DateRange } from "@angular/material/datepicker";
import type { ISymbolView } from "@bitwarden/web-vault/app/models/view/symbol/symbol.view";
import { isReadOnlySymbol } from "@bitwarden/web-vault/app/models/view/symbol/currency-utility";
import { CategoryView } from "@bitwarden/web-vault/app/models/view/category/category.view";
import { DialogWrapperComponent } from "@bitwarden/web-vault/app/components/wrappers/dialog-wrapper/dialog-wrapper.component";
import { RightPanelService } from "@bitwarden/web-vault/app/components/dialog/right-panel.service";
import { CategoriesAddEditComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-categories/categories-add-edit/categories-add-edit.component";
import { CategoryUtils } from "@bitwarden/web-vault/app/models/view/category/category.utils";
import { NotificationEnum } from "@bitwarden/web-vault/app/models/enum/notification.enum";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DatePipe } from "@angular/common";
import {
  ManualAccountGuideSteps,
  ManualAccountGuideTotalSteps,
} from "@bitwarden/web-vault/app/models/enum/guide.enum";

import { InputValueManager } from "@bitwarden/web-vault/app/shared/utils/input-value-manager";
import { DataPluginStoreService } from "@bitwarden/web-vault/app/services/store/data-plugin/data-plugin.store.service";
import { TransactionService } from "@bitwarden/web-vault/app/services/DataService/transaction/transaction.service";

@Component({
  selector: "app-add-edit-transaction-form",
  templateUrl: "./add-edit-transaction-form.component.html",
})
export class AddEditTransactionFormComponent implements OnDestroy {
  private readonly rightPanel = inject(RightPanelService);
  tabActive: InputSignal<string> = input("");
  selectedAccount: InputSignal<AccountView> = input(null);

  isEditExistingTransaction: InputSignal<boolean> = input(false);
  transactionToEdit: InputSignal<transactionDataType> = input(null);
  updateTransaction: InputSignal<ActionButton> = input(null);
  currency: InputSignal<CurrencyType> = input(null);
  selectedDateRange: InputSignal<DateRange<any>> = input<DateRange<any>>();

  symbolAndCurrencyEqualChange: OutputEmitterRef<boolean> = output();

  transactionData: OutputEmitterRef<any> = output();

  selectedCategory: WritableSignal<string> = signal("");
  protected transactionFormReady: WritableSignal<boolean> = signal(
    !this.isEditExistingTransaction(),
  );

  protected data: TransactionData;
  protected origin: WritableSignal<string> = signal(null);
  protected isLockedCurrency = signal(true);
  private categoryHasChanged: WritableSignal<boolean> = signal(false);
  private newCategoryNameAfterCreated: WritableSignal<string> = signal(null);

  private transactionStore: TransactionStoreService = inject(TransactionStoreService);
  private roleAccessService = inject(RoleAccessService);
  private notifyService: ConfirmationDialogService = inject(ConfirmationDialogService);
  private userStoreService: UserStoreService = inject(UserStoreService);
  private dataPluginStore: DataPluginStoreService = inject(DataPluginStoreService);
  private datePipe: DatePipe = inject(DatePipe);
  private localeId: string = inject(LOCALE_ID);
  private transactionService = inject(TransactionService);
  private categoryUtils = new CategoryUtils();

  protected transactionForm: TransactionForm;
  protected dialogFactory: DialogFactory;
  protected readonly ManualAccountGuideSteps = ManualAccountGuideSteps;
  protected readonly ManualAccountGuideTotalSteps = ManualAccountGuideTotalSteps;

  // Restrict to the allowed range when provided, otherwise up to today.
  protected dateFilter = (d: Date | null): boolean => {
    if (!d) {
      return false;
    }
    const range = this.selectedDateRange();
    if (range?.start && range?.end) {
      const start = new Date(range.start);
      const end = new Date(range.end);
      const startDay = new Date(start.getFullYear(), start.getMonth(), start.getDate());
      const endDay = new Date(end.getFullYear(), end.getMonth(), end.getDate());
      return d >= startDay && d <= endDay;
    }
    return d <= new Date();
  };

  onDatePicked(date: Date) {
    this.onDateChanged(this.datePipe.transform(date, "yyyy-MM-dd")!);
  }

  // A signal, not a plain field: isPriceLocked() and the price-populating effect below
  // both read it, and a plain field cannot re-trigger the effect when it flips — which
  // left Price/Unit locked but empty, so Save silently did nothing.
  isSymbolAndCurrencyEqual: WritableSignal<boolean> = signal(false);
  protected selectedStockSymbol: ISymbolView; // get this from actual stock symbols
  private inputValueManager = new InputValueManager<string | number>(); // Manage input values

  protected isFindPrice = signal(true);
  private symbolSearchInput = signal<string>("");
  private dateSearchInput = signal<string>("");

  /**
   * Logic to determine if the Price/Amount field should be disabled.
   */
  protected isPriceLocked = computed(() => {
    // Disable if Symbol and Currency are equal
    if (this.isSymbolAndCurrencyEqual()) {
      return true;
    }

    // Disable if a market rate was successfully found via the plugin
    const foundRate = this.searchedSymbol();
    if (this.isFindPrice() && foundRate?.rate) {
      return true;
    }

    return false;
  });

  protected searchedSymbol = computed(() => {
    return this.dataPluginStore.databank.references().find((ref) => {
      return ref.date.date === this.dateSearchInput() && ref.base === this.symbolSearchInput();
    });
  });

  // transactionForm.initialize() (called from the constructor and again from resetValue())
  // replaces formGroup wholesale, so a subscription taken once at construction would go stale
  // after a reset - refreshFormValueSignal() re-subscribes to whichever formGroup is current.
  private formValue: WritableSignal<Record<string, any> | null> = signal(null);
  private formValueSubscription?: Subscription;

  private refreshFormValueSignal(): void {
    this.formValueSubscription?.unsubscribe();
    this.formValue.set(this.transactionForm.formGroup.getRawValue());
    this.formValueSubscription = this.transactionForm.formGroup.valueChanges.subscribe((value) =>
      this.formValue.set(value),
    );
  }

  ngOnDestroy(): void {
    this.formValueSubscription?.unsubscribe();
  }

  isFromGuide: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    @Optional()
    public dialogData: { isFromGuide: boolean } | null,
    private injector: Injector,
    public dialog: MatDialog,
  ) {
    this.dialogFactory = new DialogFactory();
    this.isFromGuide = this.dialogData?.isFromGuide ?? false;

    const setSelectedAccountEffectRef = effect(
      () => {
        if (this.selectedAccount()) {
          this.transactionForm = new TransactionForm(this.injector, this.selectedAccount());
          this.refreshFormValueSignal();
          this.origin.set(this.selectedAccount().origin);
          const lockCurrency = isBankOrCredit(this.selectedAccount().type);
          if (lockCurrency !== this.isLockedCurrency()) {
            this.isLockedCurrency.set(lockCurrency);
          }

          this.setInitialSymbol();

          setSelectedAccountEffectRef.destroy();
        }
      },
      { allowSignalWrites: true },
    );

    effect(
      () => {
        if (this.isEditExistingTransaction() && this.transactionToEdit()) {
          this.editTransaction(this.transactionToEdit());
          this.selectedCategory.set(this.transactionToEdit().formData.categoryId);
        }
      },
      { allowSignalWrites: true },
    );

    effect(
      () => {
        const result = this.searchedSymbol();
        if (this.isFindPrice() && result?.rate && !this.isSymbolAndCurrencyEqual()) {
          this.transactionForm.formGroup.get("amount").setValue(result.rate);
        }
      },
      { allowSignalWrites: true },
    );
  }

  protected userCategoriesNames = computed(() => {
    return this.userOwnedCategories().map((category) => category.name);
  });

  protected userOwnedCategories = computed(() => {
    // Pickable options: user categories minus the currently-selected one. Excludes the
    // system categories (default / GLOSS Credits) since categoriesWithoutDefault omits them.
    const selectedId = this.selectedCategory();
    return this.userStoreService.categories
      .categoriesWithoutDefault()
      .filter((category) => category.id !== selectedId);
  });

  selectedCategories = computed(() => {
    // Resolve the chip from the full list (incl. system categories like GLOSS Credits),
    // otherwise a credits/default transaction's category resolves to undefined -> blank chip.
    const allCategories = this.userStoreService.categories.categoryViewsSorted();
    const categories: CategoryView[] = [];
    if (this.selectedCategory()) {
      categories.push(findCategoryById(allCategories, this.selectedCategory()));
    }
    return categories.filter((category) => category !== null && category !== undefined);
  });

  protected checkAllowedType = computed(() =>
    Object.values(accountManualType).find((type) => type === this.selectedAccount().type),
  );

  /**
   * Defaults the symbol field to the symbol this account last transacted in, so Add Transaction
   * and Add Balance agree for the same account. Stock/other only — bank/credit have no symbol
   * (the dropdown, the price fetch and the equality check are all stock/other-gated), so this
   * returns early for them rather than planting an alphabetical fallback the user can't see or
   * correct (#4590: that fallback rewrote the stored money symbol on a bank/credit add).
   *
   * Falls back to the alphabetically-first option when there is no usable account symbol (one that
   * is no longer among the current options). A transaction-less account is not a fallback case —
   * the enriched collection synthesises an empty_account_balance transaction carrying the account's
   * own currency, so a stock/other account always resolves to something.
   */
  private setInitialSymbol(): void {
    const account = this.selectedAccount();
    // #4590 add-path guard: bank/credit have no symbol. The dropdown never renders for them, and
    // checkAndHandleSymbolCurrencyEquality plus triggerPriceFetch() are themselves
    // stock/other-gated (the edit path via #5133), so patching a symbol here just plants a bogus
    // one the user can't see — and seeding symbolSearchInput can trigger a spurious market-rate
    // overwrite of the amount. Bail so bankFormToTransactionView's `symbol || currency` fallback
    // keeps the account's currency as the money symbol.
    if (!isStockOrOther(account.type)) {
      return;
    }
    const options = this.symbolsAndCurrencies();

    const accountSymbolCode = this.transactionService.getMostRecentSymbolForAccount(account);
    let initialSymbolCode =
      accountSymbolCode && options.some((o) => o.realValue === accountSymbolCode)
        ? accountSymbolCode
        : null;

    if (!initialSymbolCode) {
      const firstOption = options.slice().sort((a, b) => a.realValue.localeCompare(b.realValue))[0];
      initialSymbolCode = firstOption?.realValue ?? null;
    }

    this.transactionForm.formGroup.patchValue({ symbol: initialSymbolCode });

    // Set the signals used for price lookup
    this.symbolSearchInput.set(initialSymbolCode);
    this.dateSearchInput.set(this.transactionForm.formGroup.get("date").value);

    // Check if symbol and currency are equal after initialization
    this.checkAndHandleSymbolCurrencyEquality();
  }

  symbolsAndCurrencies = computed(() => {
    // Excludes currencies and GLOSS Credits ("CrS"/"CrP") - both are represented in
    // generatedSymbols but neither is a tradeable asset a transaction can be denominated in.
    // Shared with TransactionService.getSelectableBalanceSymbols() so the two lists can't drift
    // again (#4564).
    const symbols = this.transactionStore.generatedSymbols
      .collection()
      .filter((s) => !isReadOnlySymbol(s.code));

    let currencies: string[] = [];
    currencies = this.roleAccessService.getRoleAccess().getClaim().forex_currency as string[];

    const mappedSymbols = symbols.map((s) => ({
      realValue: s.code,
      optionDisplayValue: s.sources?.[ReferenceDataSource.MANUAL] || s.code,
      selectedDisplayValue: s.sources?.[ReferenceDataSource.MANUAL] || s.code,
      enabled: true,
    }));

    const mappedCurrencies = currencies.map((c) => ({
      realValue: c,
      optionDisplayValue: c,
      selectedDisplayValue: c,
      enabled: true,
    }));

    return mappedSymbols.concat(mappedCurrencies);
  });

  protected displaySourceText = computed(() =>
    this.origin() === InstitutionOriginEnum.manual
      ? InstitutionOriginEnum.manual
      : InstitutionOriginEnum.auto,
  );

  /**
   * Checks if the current symbol and currency in the form are equal
   * and triggers the amount field state change
   */
  private checkAndHandleSymbolCurrencyEquality(): void {
    if (isStockOrOther(this.selectedAccount().type)) {
      const symbol = this.transactionForm.formGroup.get("symbol").value;
      const currency = this.transactionForm.formGroup.get("currency").value;
      this.handleAmountValueOnSymbolCurrencyChange(currency === symbol);
    }
  }

  /**
   * Handles amount field value based on symbol/currency equality state change
   * Sets amount to 1 and locks it when symbol equals currency, restores when different
   */
  private handleAmountValueOnSymbolCurrencyChange(newState: boolean): void {
    // Read untracked: this runs inside the edit effect, and tracking the signal there would
    // make a currency change re-run the effect and reset the form back to the original values.
    const previousState = untracked(this.isSymbolAndCurrencyEqual);
    this.isSymbolAndCurrencyEqual.set(newState);

    if (previousState !== newState) {
      const currentAmount = this.transactionForm.formGroup.get("amount").value;

      if (newState) {
        // Symbol equals currency - save current value and set to 1
        this.inputValueManager.saveAndClear("amount", currentAmount);
        this.transactionForm.formGroup.get("amount").setValue(1);
      } else {
        // Symbol different from currency - restore previous value
        const restoredAmount = this.inputValueManager.restore("amount", currentAmount);
        this.transactionForm.formGroup.get("amount").setValue(restoredAmount);
      }
    }

    this.symbolAndCurrencyEqualChange.emit(newState);
  }

  onCategoryChange(categoryName: string) {
    const category = findCategoryByName(this.userOwnedCategories(), categoryName);
    if (category) {
      const newCategoryId = category.id;
      this.transactionForm.selectCategory(newCategoryId);
      this.selectedCategory.set(newCategoryId);
      this.categoryHasChanged.set(true);
    }
  }

  removeCategoryFromDisplay(category: CategoryView) {
    this.selectedCategory.set("");
    this.transactionForm.selectCategory(null);
    this.categoryHasChanged.set(true);
  }

  openAddCategoryForm() {
    this.rightPanel.open(DialogWrapperComponent, {
      data: {
        title: "createNewCategory",
        showBackButton: false,
        component: CategoriesAddEditComponent,
        fullyCustomised: true,
        showHeaderCloseButton: true,
        componentInputs: {
          category: null,
          actionSucceeded: this.addCategorySuccessful.bind(this),
        },
      },
    });
  }

  // Inline "Add New Category": create it directly and select it (single-category).
  async createCategory(name: string) {
    try {
      const created = await this.categoryUtils.addNewCategory(name, this.userStoreService);
      this.onCategoryChange(created.name);
      this.notifyService.notify(NotificationEnum.success, "succeeded", "createdSuccessfully");
    } catch (error) {
      const isDuplicate = error instanceof Error && error.message === "duplicateNameError";
      if (isDuplicate) {
        this.notifyService.notify(NotificationEnum.warning, "warning", "categoryNameInfo");
      } else {
        this.notifyService.notify(NotificationEnum.error, "error", "errorOccurred");
      }
    }
  }

  addCategorySuccessful(response: { newCategoryText: string; successfulText: string }) {
    this.newCategoryNameAfterCreated.set(response.newCategoryText);
    this.onCategoryChange(response.newCategoryText);
    this.notifyService.notify(NotificationEnum.success, "succeeded", response.successfulText);
  }

  editTransaction(inActionTransaction: transactionDataType) {
    this.transactionForm.currentAccount = this.selectedAccount();
    this.transactionForm.selectedAccount = inActionTransaction.account;
    this.transactionForm.isEditTransaction = true;
    if (inActionTransaction) {
      const editData = inActionTransaction.formData;
      this.transactionForm.formGroup.patchValue({ type: editData.type });
      const editExisitngTransaction = {
        description: editData.description,
        time: editData.time,
        date: editData.date,
        amount: editData.amount,
        currency: editData.currency,
        transactionStatus: TransactionStatusEnum.transaction,
        type: editData.type,
        categoryId: editData.categoryId,
        quantity: editData.quantity,
        symbol: editData.symbol,
      };
      this.transactionForm.formGroup.reset(editExisitngTransaction);
      this.transactionFormReady.set(true);

      // #5133 edit-path guard (mirrors #4802 on setInitialSymbol): only stock/other
      // accounts have a real symbol to price. For bank/credit, editData.symbol is the
      // account currency (e.g. "AUD"); seeding it and firing the fetch matched an
      // arbitrary forex quote and overwrote the user's amount with that rate on a plain
      // edit. (checkAndHandleSymbolCurrencyEquality is itself isStockOrOther-gated, so the
      // equality flag stayed false and no longer suppressed the fetch.)
      if (isStockOrOther(this.selectedAccount().type)) {
        // Equality before the fetch: triggerPriceFetch() is guarded on that flag.
        this.symbolSearchInput.set(editData.symbol);
        this.dateSearchInput.set(editData.date);
        this.checkAndHandleSymbolCurrencyEquality();
        this.triggerPriceFetch();
      }
    }
  }

  onCurrencySelected(currency: string) {
    this.transactionForm.selectCurrency(currency);
    this.checkAndHandleSymbolCurrencyEquality();
  }

  openAddSymbolDialog() {
    this.dialogFactory.addSymbol((symbol) => this.onStockSymbolSelected(symbol.code));
  }

  onStockSymbolSelected(stockSymbol: string) {
    if (isStockOrOther(this.selectedAccount().type)) {
      const symbols = this.transactionStore.generatedSymbols
        .collection()
        .find((s) => s.code === stockSymbol);

      if (symbols) {
        this.selectedStockSymbol = symbols;
        // Only set the symbol, don't change the currency
        // The user should manually set currency if they want it to match
        this.transactionForm.formGroup.get("symbol").setValue(symbols.code);
      } else {
        // For 'other' account types, set both symbol and currency to the same value
        this.transactionForm.formGroup.get("symbol").setValue(stockSymbol);
      }

      // Check if symbol and currency are equal after symbol is set
      this.symbolSearchInput.set(stockSymbol);
      // Equality first: triggerPriceFetch() is guarded on this flag, so fetching
      // before updating it skips the lookup for the newly picked symbol.
      this.checkAndHandleSymbolCurrencyEquality();
      this.triggerPriceFetch();
    }
  }

  onDateChanged(date: any) {
    this.transactionForm.onDateChange(date);
    this.dateSearchInput.set(date);
    this.triggerPriceFetch();
  }

  private triggerPriceFetch() {
    // Sink-side #5133 guard: the three symbol-seeding sites are each stock/other-gated, but
    // onDateChanged() calls this ungated and the date picker renders for every account type.
    // Only an empty symbolSearchInput keeps that harmless today — gate here so it stays that
    // way for any future caller.
    if (!isStockOrOther(this.selectedAccount().type)) {
      return;
    }
    const symbol = this.symbolSearchInput();
    const date = this.dateSearchInput();
    if (symbol && date && !untracked(this.isSymbolAndCurrencyEqual)) {
      this.dataPluginStore.databank.fetch({
        type: "references",
        limit: 20,
        symbol: symbol,
        date: date,
        reliableTimeSource: true,
      });
    }
  }

  /**
   * Live, human-readable preview of the transaction currently being entered
   * (e.g. "You're recording a gain of 2 GOLD at $3,450.00 AUD each ($6,900.00 AUD total) on 27 Jul 2026.").
   * Degrades gracefully as fields are filled in — direction and date always have
   * defaults, so this renders from the moment the form appears, before amount/quantity
   * are entered.
   */
  protected liveSummaryText = computed((): string | null => {
    const form = this.formValue();
    if (!form) {
      return null;
    }

    // Form values come from custom inputs bound via a generic FormControl (not the
    // Angular NumberValueAccessor, since `type` is a property binding), so numeric
    // fields arrive as strings and must be parsed before doing arithmetic on them.
    const { amount, quantity, symbol, currency, date, type } = form;
    if (!date || !currency) {
      return null;
    }

    const i18nService = this.transactionForm.i18nService;
    // transform() only returns null for a null/'' input, which is already excluded above.
    const formattedDate = this.datePipe.transform(date, "d MMM yyyy")!;
    const isGain = type === TransactionDirection.In;

    const numericAmount = Number(amount);
    const hasAmount =
      amount !== null && amount !== undefined && amount !== "" && !isNaN(numericAmount);

    if (isStockOrOther(this.selectedAccount()?.type)) {
      const numericQuantity = Number(quantity);
      const hasQuantity =
        quantity !== null &&
        quantity !== undefined &&
        quantity !== "" &&
        !!symbol &&
        !isNaN(numericQuantity);

      // A price/total clause is noise when the price is the forced 1 the user can't edit and
      // didn't enter (handleAmountValueOnSymbolCurrencyChange, isPriceLocked). Keyed off the
      // value, not the flag alone: the forcing only fires on a state *transition*, so a stored
      // amount != 1 survives editTransaction() when the flag was already true at init - that
      // price is real and shown in the field, so the clause belongs.
      const hasPrice = hasAmount && !(this.isSymbolAndCurrencyEqual() && numericAmount === 1);

      if (hasQuantity && hasPrice) {
        const total = numericAmount * numericQuantity;
        const details = i18nService.t(
          "liveSummaryPriceEachTotal",
          this.formatSummaryAmount(numericAmount, currency),
          this.formatSummaryAmount(total, currency),
        );
        const key = isGain ? "liveSummaryGainDetailed" : "liveSummaryLossDetailed";
        return i18nService.t(
          key,
          this.formatSummaryQuantity(numericQuantity, symbol),
          details,
          formattedDate,
        );
      }

      if (hasQuantity) {
        const key = isGain ? "liveSummaryGainQuantityOnly" : "liveSummaryLossQuantityOnly";
        return i18nService.t(
          key,
          this.formatSummaryQuantity(numericQuantity, symbol),
          formattedDate,
        );
      }

      if (hasPrice) {
        const key = isGain ? "liveSummaryGainPriceOnly" : "liveSummaryLossPriceOnly";
        return i18nService.t(key, this.formatSummaryAmount(numericAmount, currency), formattedDate);
      }

      const key = isGain ? "liveSummaryGainBasic" : "liveSummaryLossBasic";
      return i18nService.t(key, formattedDate);
    }

    // Credit accounts land here too (isStockOrOther() is only stock/other), so an inbound
    // movement reads as "a deposit" - usually a charge/payment reversal, not a deposit. The
    // amount field also accepts negatives, giving "a deposit of -$50.00 AUD". Both are product
    // calls, not engineering ones - left as-is pending that input (#4503).
    if (hasAmount) {
      const key = isGain ? "liveSummaryDeposit" : "liveSummaryWithdrawal";
      return i18nService.t(key, this.formatSummaryAmount(numericAmount, currency), formattedDate);
    }

    const key = isGain ? "liveSummaryDepositBasic" : "liveSummaryWithdrawalBasic";
    return i18nService.t(key, formattedDate);
  });

  private formatSummaryAmount(amount: number, currency: string): string {
    return `${formatCurrencyAmount(amount, currency, this.localeId)} ${currency}`;
  }

  // The quantity form control is a string (see liveSummaryText's own note on that), so
  // interpolating it raw put un-localised, unformatted text (e.g. "2.5000", "007") next to
  // formatSummaryAmount's locale-grouped output in the same sentence (#4503).
  private formatSummaryQuantity(quantity: number, symbol: string): string {
    // Intl defaults to maximumFractionDigits: 3 - fractional shares and crypto need the entry intact.
    return `${new Intl.NumberFormat(this.localeId, { maximumFractionDigits: 20 }).format(quantity)} ${symbol}`;
  }

  completeForm() {
    this.transactionForm.formGroup.markAllAsTouched();
    return this.transactionForm.submit();
  }

  resetValue() {
    this.transactionForm.initialize();
    this.refreshFormValueSignal();
    this.selectedCategory.set("");
    // this.tabActive.set(editTransactionTab.transactionDetails);
  }

  protected readonly editTransactionTab = editTransactionTab;
  protected readonly InstitutionOriginEnum = InstitutionOriginEnum;
  protected readonly accountManualType = accountManualType;
}
